import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/i18n-react';
import { Divider, Stack } from '@fiverr-private/layout_components';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { List, ListItem, ListItemIcon } from '@fiverr-private/list';
import { CheckIcon } from '@fiverr-private/visuals';
import { Button } from '@fiverr-private/button';
import { ElementType } from '@fiverr-private/bianka_js';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import hasTranslation from '@fiverr-private/i18n-react/src/hasTranslation';
import { reportClick } from '../../utils/biEvents/events/biankaEvents';
import { sendMixPanelEvent } from '../../utils/biEvents';
import { MP_FIVERR_PACKAGE_CLICKED } from '../../utils/biEvents/events/mixPanelEvents';
import { packageSubtitleClass } from './styles.ve.css';

const COPY_KEY_PREFIX = 'logged_out_homepage.pro_packages_banner.fiverr_package';
const FIVERR_BENEFITS_COUNT = 5;

export const FiverrPackage = () => {
    const benefits = Array.from(Array(FIVERR_BENEFITS_COUNT).keys()).filter((index) =>
        hasTranslation(`${COPY_KEY_PREFIX}.benefits.${index + 1}`)
    );
    const joinFiverrClick = async () => {
        try {
            await triggerSignUp({
                biEnrichmentParams: {
                    page: {
                        component: {
                            name: 'lohp_business_banner',
                        },
                    },
                },
            });
        } catch {
            window.open(pathfinder('join', undefined, { query: { source: 'LOHP_business_banner' } }));
        }

        reportClick({
            eventName: 'clicked_on_join_fiverr',
            elementName: 'join_fiverr',
            elementType: ElementType.BUTTON,
        });
        sendMixPanelEvent({ eventName: MP_FIVERR_PACKAGE_CLICKED });
    };

    return (
        <Stack
            direction="column"
            justifyContent="spaceBetween"
            gap="0"
            paddingX="6"
            paddingY="9"
            borderRadius="xl"
            overflow="hidden"
            boxShadow="z2"
            flexGrow="1"
            flexBasis="350px"
            backgroundColor="white"
            minWidth={{ default: 'auto', lg: '320px', xl: '350px' }}
        >
            <Stack direction="column" gap="0">
                <Heading as="h4" size="h_sm" fontWeight="bold">
                    <I18n k={`${COPY_KEY_PREFIX}.title`} />
                </Heading>
                <Text
                    marginTop="2"
                    height={{
                        default: 'auto',
                        lg: '48px',
                        xl: 'auto',
                    }}
                    className={packageSubtitleClass}
                    size={{
                        default: 'b_sm',
                        md: 'b_md',
                    }}
                >
                    <I18n k={`${COPY_KEY_PREFIX}.subtitle`} />
                </Text>
                <Divider marginY="4" />
                <Typography color="grey_1000" fontWeight="semibold" size="b_sm">
                    <I18n k={`${COPY_KEY_PREFIX}.key_benefits`} />
                </Typography>
                <List marginTop="4" paddingLeft="0">
                    {benefits.map((index) => (
                        <ListItem key={index}>
                            <ListItemIcon>
                                <CheckIcon size="md" color="green_700" />
                            </ListItemIcon>
                            <Typography size="b_sm" color="grey_1100">
                                <I18n k={`${COPY_KEY_PREFIX}.benefits.${index + 1}`} />
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </Stack>
            <Stack direction="column" gap="0" marginTop="8">
                <Button variant="outline" onClick={joinFiverrClick}>
                    <I18n k={`${COPY_KEY_PREFIX}.join_fiverr`} />
                </Button>
                <Typography
                    size="b_sm"
                    color="grey_1100"
                    fontWeight="semibold"
                    marginTop="6"
                    textAlign="center"
                    height={{
                        default: 'auto',
                        lg: '44px',
                        xl: 'auto',
                    }}
                >
                    <I18n k={`${COPY_KEY_PREFIX}.always_free`} />
                </Typography>
            </Stack>
        </Stack>
    );
};
